import { render } from "./ChartOfAccounts.vue?vue&type=template&id=7a0c97a6&scoped=true"
import script from "./ChartOfAccounts.vue?vue&type=script&lang=js"
export * from "./ChartOfAccounts.vue?vue&type=script&lang=js"

import "./ChartOfAccounts.vue?vue&type=style&index=0&id=7a0c97a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0c97a6"]])

export default __exports__